import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UsuarioEmpresaInserirRoutingModule } from './usuario-empresa-inserir-routing.module';
import { UsuarioEmpresaInserirComponent } from './usuario-empresa-inserir.component';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TreeModule } from 'primeng/tree';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { MessagesModule } from 'primeng/messages';
import { DropdownModule } from 'primeng/dropdown';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputMaskModule } from 'primeng/inputmask';
import { TooltipModule } from 'primeng/tooltip';
import { TreeTableModule } from 'primeng/treetable';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';


@NgModule({
  declarations: [
    UsuarioEmpresaInserirComponent
  ],
  imports: [
    CommonModule,
    UsuarioEmpresaInserirRoutingModule,
    FormsModule,
    DialogModule,
    ButtonModule,
    InputTextModule,
    InputMaskModule,
    DividerModule,
    MessagesModule,
    DropdownModule,
    InputSwitchModule,
    TooltipModule,
    TreeTableModule,
    ProgressSpinnerModule,
    ConfirmDialogModule
  ],
  providers: [ConfirmationService]
})
export class UsuarioEmpresaInserirModule { }
